module.exports = __webpack_public_path__ + "static/media/1.ccdc1ddb.jpg";